@if (displayStatus()) {
  <div
    aionzProductIntegrationNotification
    [status]="displayStatus()!"
    class="notification-container"
    #notificationDirective="aionzProductIntegrationNotification">
    <mat-icon
      class="status-icon"
      alt="">
      {{ notificationDirective.getIcon() }}
    </mat-icon>

    <span class="notification-message">
      {{ displayMessage() }}
    </span>

    <button
      class="close-button"
      (click)="close()"
      aria-label="Fechar notificação">
      <mat-icon alt="">close</mat-icon>
    </button>
  </div>
}
